import Cato from '../../../assets/catoHalloween.svg';
import CatoB2b from '../../../assets/catob2b.svg';
import { IsB2bAgent } from '../../../utils/isB2bAgent';

const CatoLogo = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return !IsB2bAgent() ? <Cato {...props} /> : <CatoB2b {...props} />;
};

export default CatoLogo;
